module.exports = __webpack_public_path__ + "files/41b545c145212d0383d8f1d1e070cef4.svg";